<template>
    <div class="vacancy-page page my-container">
        <div class="row">
            <h1 class="header">{{ t('vacancy') }}</h1>
            <div>
                <p class="description">
                    {{ vacancy['section-1'].description[locale] }}
                </p>
                <NuxtLink :to="vacancy['section-1'].link" class="my-btn">{{ t('seeVacancy') }}</NuxtLink>
            </div>
        </div>
        <img alt="vacancy banner" :src="vacancy['section-1'].media_file"
            v-if="vacancy['section-1'].media_file_type === 'image'" />
        <video style="width: 100%; object-fit: cover; object-position: center;" v-else>
            <source :src="vacancy['section-1'].media_file" type="video/mp4" />
        </video>
        <div class="row">
            <div>
                <h2 class="header">{{ t('noVacancy') }}</h2>
                <p class="disclaimer">{{ t('vacancyDisclaimer') }}</p>
            </div>
            <form class="vacancy-form" @submit.prevent="sendForm">
                <BaseInput variant="light" :placeholder="t('yourEmail')" v-model="form.email"
                    :class="{ error: validator.email.$error }" />
                <BaseInput variant="light" :placeholder="t('fio')" v-model="form.fio"
                    :class="{ error: validator.fio.$error }" />
                <ClientOnly>
                    <BasePhoneInput v-model="form.phone" default-country="UZ" variant="light"
                        :error="validator.phone.$error" :search-placeholder="t('enterSearchQuery')" />
                    <template #fallback>
                        <input class="base-input light" :placeholder="t('yourPhone')" disabled />
                    </template>
                </ClientOnly>
                <BaseInput variant="light" :placeholder="t('interestedVacancy')" v-model="form.position"
                    :class="{ error: validator.position.$error }" />
                <input @change="handleFile" ref="fileInput" type="file" style="visibility: hidden; position: absolute"
                    accept=".doc,.docx,.pdf">
                <button class="my-btn third span2 flex align-center justify-center" type="button"
                    @click="(form.cv === null, fileInput.click())" :class="{ error: validator.cv.$error }">
                    {{ form.cv ? form.cv.name : t('yourCV') }}
                </button>
                <textarea rows="4" class="base-input span2 light" :placeholder="t('requestComment')"
                    v-model="form.letter" :class="{ error: validator.letter.$error }"></textarea>
                <button class="my-btn span2 flex align-center justify-center"> {{ t('send')
                    }}</button>
            </form>
        </div>
    </div>
</template>

<script setup>
const { locale, t } = useI18n()
import { useVuelidate } from '@vuelidate/core'
import { required, email } from '@vuelidate/validators'
const rc = useRuntimeConfig()

const { start, finish } = useLoadingIndicator()
const toast = useToast();
const vacancy = ref((await $fetch(rc.public.api + '/api/sections/vacancy')).data)
const fileInput = ref()
const form = reactive({
    cv: null,
    email: '',
    fio: '',
    phone: '',
    position: '',
    letter: ''

})
function handleFile(e) {
    if (e.target.files[0])
        form.cv = e.target.files[0]
}

const rules = computed(() => ({
    cv: { required },
    email: { required, email },
    fio: { required },
    phone: { required },
    position: { required },
    letter: { required }
}))
const validator = useVuelidate(rules, form)
async function sendForm() {
    const isValid = await validator.value.$validate()
    if (!isValid) return toast.add({
        title: t('fillForm'),
        color: 'red'
    });
    try {
        const body = new FormData();
        body.append('cv', form.cv)
        body.append('email', form.email)
        body.append('name', form.fio)
        body.append('phone', form.phone)
        body.append('position', form.position)
        body.append('letter', form.letter)
        start()
        await $fetch(rc.public.api + '/api/application/vacancy', {
            body,
            method: 'POST'
        })
        toast.add({
            title: t('contactSuccess'),
        })
        resetForm()
    } catch (error) {
        toast.add({
            title: error?.data?.context?.message || error?.data?.message || t('errorOccured'),
            color: 'red'
        })
    } finally {
        finish()
    }
}
function resetForm() {
    form.cv = null;
    form.email = ''
    form.fio = ''
    form.phone = ''
    form.position = '';
    form.letter = ''
    validator.value.$reset()
}

</script>